const CacheKeys = {
  CHAT_ACTIVE: "isChatActive",
  CHAT_RECEIVER_ID: "chatReceiverId",
  RAND_ID: "randId",
  TOAST: "toast",
};

export default CacheKeys;
